import { createContext, useContext } from 'react';
import type React from 'react';
import type { useSphereArchetypes } from '../../../../hooks/useSphereArchetypes';

export interface SphereIdentityContextValue {
  archetypesState: ReturnType<typeof useSphereArchetypes>;
  /** Named only when the server says the authority to assign archetypes is the sphere's own person. */
  archetypesOwnerName?: string;
  isNewSphere: boolean;
  /** Sphere-level edit answer; the description is not a section property, so the section's own answer does not apply. */
  editable: boolean;
  /**
   * Renders the inline visual control, bound to the sphere's one visual state, which the header renders
   * too. `labelledBy` is the id of the row's visible label. Absent for a new sphere.
   */
  renderVisualRow?: (labelledBy: string) => React.ReactNode;
  /** The expected-aspects summary, which sits directly under the archetypes field it summarises. */
  expectedAspectsSummary?: React.ReactNode;
}

const SphereIdentityContext = createContext<SphereIdentityContextValue | null>(null);

export const SphereIdentityProvider = SphereIdentityContext.Provider;

export const useSphereIdentityContext = (): SphereIdentityContextValue | null => useContext(SphereIdentityContext);
